<template>
  <DpplTooltip
    :tooltip-offset="12"
  >
    <template #activator="{ onMouseenter, onMouseleave }">
      <div
        class="badge"
        @mouseenter="onMouseenter"
        @mouseleave="onMouseleave"
      >
        Non-English
      </div>
    </template>
    <template #tooltip-content>
      <p class="tooltip-content">
        This job post is excluded from reports.
      </p>
    </template>
  </DpplTooltip>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
</script>

<style lang="less" scoped>
.badge {
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  border: 1px solid @stroke-default;
  font-size: 12px;
  font-weight: 500;
  border-radius: 24px;
  color: @basic-yellow;
}

.tooltip-content {
  font-size: 13px;
  font-weight: 500;
  color: @text-darkest;
}
</style>
